import http from '@/http'
const URL = '/admin/settings/wa/templates'

export const getMode = () => http.get(`${URL}/mode`)

export const list = (params) => http.get(URL, { params })

export const syncFromMeta = () => http.get(`${URL}/sync`)

export const createTemplate = (payload) => {
  if (payload instanceof FormData) {
    return http.post(URL, payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
  return http.post(URL, payload)
}

export const updateTemplate = (id, payload) => http.put(`${URL}/${id}`, payload)

export const deleteTemplate = (id) => http.delete(`${URL}/${id}`)

export const refreshStatus = (id) => http.post(`${URL}/${id}/refresh-status`)

export const uploadSample = (formData) => http.post(`${URL}/upload-sample`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
})

export const sendTest = (id, payload) => http.post(`${URL}/${id}/send-test`, payload)

export default {
  list,
  syncFromMeta,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  refreshStatus,
  uploadSample,
  sendTest
}
